// Copyright (c) 2016 Deere & Company

import {
    isNotEmpty,
    isNotNull,
    isRepairDateAfterFailureDate,
    validateClaimUseAmountUnits,
    validateClaimUseAmounts
} from '../../shared/services/claim-shared-helper';

export const canShowAllSections = (claimNumber, isValidClaim) =>
    isValidClaim || isNotEmpty(claimNumber);

export const isValidClaim = (claim, nonSerialized) => [
    isNotEmpty(claim.failureInfo.failurePartNumber),
    isNotEmpty(claim.pin),
    validateClaimUseAmountUnits('', claim) || nonSerialized,
    validateClaimUseAmounts('', claim) || nonSerialized,
    isNotEmpty(claim.responsibleAccount.account),
    isNotEmpty(claim.referenceInfo.ownershipStatus.key),
    isNotEmpty(claim.referenceInfo.referenceNumber1),
    isNotEmpty(claim.pipProgram.description),
    isNotEmpty(claim.pipProgram.internalRecall),
    isNotEmpty(claim.pipProgram.pipNumber),
    isNotNull(claim.failureInfo.failureDate),
    isNotNull(claim.failureInfo.repairDate),
    isRepairDateAfterFailureDate(claim.failureInfo.repairDate, claim.failureInfo.failureDate)
].every(rule => rule);

export const mapFormValidation = (property, value, claim) => {

    const map = {
        complaintCorrection: isNotEmpty,
        failureDate: isNotNull,
        failurePart: isNotEmpty,
        ownershipStatus: isNotEmpty,
        pin: isNotEmpty,
        pipNumber: isNotEmpty,
        repairDate: isNotNull,
        responsibleAccount: isNotEmpty,
        useAmount: validateClaimUseAmounts,
        useAmountUnit: validateClaimUseAmountUnits,
        workOrderOne: isNotEmpty
    };

    return map[property](value, claim);

};

export const checkClaimValidity = (currentPageValidity, validationFailed, selectedAction) =>
    selectedAction === 'VALIDATE' ?
        !validationFailed && !currentPageValidity :
        false;



// WEBPACK FOOTER //
// ./src/claim/pip/services/claim-validation-helper.js